class Wervingwijzer {
  element: any;
  items: any;

  constructor() {
    this.element = $(".wervingwijzer").find(".umbraco-forms-container");
    // Count all fieldsets inside this element
    const total = this.element.find("fieldset").length;
    this.element.css("--total-fieldsets", total);
    this.items = this.element.find('fieldset');
    this.items.each((index, item) => {
        let items = $(item);
        console.log(item, (index + 1), "/", total)

        items.find("legend").append('<span class="field-counter">'+(index + 1) + '<span class="field-counter__light">/' + total+'</span></span>')
    });

  }

}

let wervingwijzer = new Wervingwijzer();
